import { Injectable, inject } from '@angular/core';
import {
  HttpClient
} from '@angular/common/http';

import {environment} from '@environments/environment';

@Injectable({providedIn: 'root'})
export class UserService {
  private http = inject(HttpClient);


  private baseApiUrl = environment.apiUrl;
  private userUrl = this.baseApiUrl + '/api/v1/user';

  getAll(params?: any) {
    return this.http.get(`${this.userUrl}`, {params});
  }

  getById(id: number) {
    return this.http.get(`${this.userUrl}/${id}`);
  }

  getRoles() {
    return this.http.get(`${this.userUrl}/roles`);
  }

  /**
   * The dormancy thresholds and exemptions currently in force, so the Users list can
   * explain its own filter rather than repeating numbers that may have been changed.
   */
  getDormancyPolicy() {
    return this.http.get(`${this.userUrl}/dormancy-policy`);
  }

  addUser(body: any) {
    return this.http.post(`${this.userUrl}`, body);
  }

  editUser(body: any, id: number) {
    return this.http.put(`${this.userUrl}/${id}`, body);
  }

  deleteUser(id: number) {
    return this.http.delete(`${this.userUrl}/${id}`);
  }

  reactivateUser(id: number) {
    return this.http.post(`${this.userUrl}/${id}/reactivate`, {});
  }

  unlockUser(id: number) {
    return this.http.post(`${this.userUrl}/${id}/security-unlock`, {});
  }

  /** Super administrators only: removes every MFA factor of someone who lost theirs. */
  clearMfa(id: number) {
    return this.http.delete(`${this.baseApiUrl}/api/v1/auth/mfa/users/${id}`);
  }

  UserLoginInfoMail(id: number) {
    return this.http.post(`${this.userUrl}/${id}/sendLoginInfoMail`, {});
  }
}
